<!--
 * $Description: 
 * $Author: Betway
 * @最后编辑: Betway
 * $Date: 2020年03月13日 10:18:19 +0800
 * @最后修改时间: 2021-12-28 14:28:02
 * @FilePath: \mrc-ess-fronted\src\Page\EssAdmin\Leave\LeaveReason\LeaveReason.vue
 -->
<template>
  <ContentLayout
    :title="$t('label_essweb_leaveReason_list_title')"
    pad="0"
    :addBtn="hasBtn('add-admin-leave-reason')"
    @new="toNew"
  >
    <!-- content -->
    <template v-slot:page-main>
      <Tabler
        :headers="headers"
        :items="desserts"
        :showSelect="showSelect"
        :height="$vuetify.breakpoint.height - 275"
        :totalCount="totalCount"
        @change="
          (page, perpage, callback) => {
            getList(page, perpage, callback);
          }
        "
      >
        <template v-slot:item.name="{ item }">
          <div
            class="text--primary table-title"
            :title="$getCommonLangValue(item.leave_reason_name)"
          >
            {{ $getCommonLangValue(item.leave_reason_name) }}
          </div>
          <!-- <div class="text--secondary table-subtitle">
            {{ $getCommonLangValue(item.leave_reason_description) }}
          </div> -->
        </template>
        <template v-slot:item.type="{ item }">
          <div
            class="text--primary table-title"
            :title="$getCommonLangValue(item.leave_type_name)"
          >
            {{ $getCommonLangValue(item.leave_type_name) }}
          </div>
        </template>
        <template v-slot:item.action="{ item }">
          <tableListTools
            :uuid="item.uuid"
            :delBtn="hasBtn('delete-admin-leave-reason')"
            :editBtn="hasBtn('edit-admin-leave-reason')"
            :viewBtn="hasBtn('view-admin-leave-reason')"
            :title="$t('label_essweb_leaveReason_list_title')"
            @delete="toDelete"
            @edit="toEdit"
            @view="toEdit"
          />
        </template>
      </Tabler>
    </template>
  </ContentLayout>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  name: "LeaveReason",
  computed: {},
  data() {
    return {
      showSelect: false,
      selected: [],
      totalCount: 0,
      headers: [
        {
          text: "label_essweb_leaveReason_list_leaveReasonNameLabel",
          value: "name",
          align: "start",
          sortable: false,
        },
        {
          text: "label_essweb_leaveReason_list_leaveTypeLabel",
          value: "type",
          align: "start",
          sortable: false,
        },
        {
          text: "label_essweb_list_components_tools_actionLabel",
          value: "action",
          align: "end",
          sortable: false,
        },
      ],
      desserts: [],
    };
  },
  mounted() {
    this.getBtnPermissionList();
    this.getList(1, this.$tableSetting.perPageSize, null);
  },
  methods: {
    getList: function (page, perpage, callback) {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_lv_leave_reason",
        url: "/leave-reason/get-list/",
        data: { cpage: page, pagesize: perpage },
      }).then((res) => {
        that.desserts = res.data;
        that.totalCount = res.totalcount;
        callback ? callback() : null;
      });
    },
    toNew: function () {
      this.$toPage("/admin/leave-reason/add", {});
    },
    toEdit: function (uuid, action) {
      this.$toPage(
        (action == "edit"
          ? "/admin/leave-reason/edit/"
          : "/admin/leave-reason/detail/") + uuid
      );
    },
    toDelete: function (uuid) {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_lv_leave_reason",
        url: "/leave-reason/delete/",
        data: { uuids: uuid },
      }).then((res) => {
        that.$showMessage({
          text: that.$t(
            "message_essweb_leaveReason_list_deleteLeaveReasonSuccessLabel"
          ),
          type: "success",
        });
        that.desserts = that.desserts.filter((ele) => ele.uuid !== uuid);
      });
    },
    toEditAll: function () {
      this.showSelect = !this.showSelect;
    },
  },
};
</script>
